import React from 'react';
import SelectDatasetType from '../containers/SelectDatasetType';
import AddDatasetAttachments from '../attachments/components/AddDatasetAttachments';
import DatasetCatalogueSection from '../catalogue/components/DatasetCatalogueSection';
import DatasetSettings from '../settings/containers/DatasetSettings';
import AddDatasetDictionaries from '../dictionaries/containers/AddDatasetDictionaries';
import { datasetSteps } from '../constants';

const wizardContent = {
  [datasetSteps.START.name]: { component: SelectDatasetType },
  [datasetSteps.FIRST_SECTION.name]: { component: DatasetCatalogueSection, section: 'first' },
  [datasetSteps.SECOND_SECTION.name]: { component: DatasetCatalogueSection, section: 'second' },
  [datasetSteps.THIRD_SECTION.name]: { component: DatasetCatalogueSection, section: 'third' },
  [datasetSteps.ATTACHMENTS.name]: { component: AddDatasetAttachments },
  [datasetSteps.DICTIONARIES.name]: { component: AddDatasetDictionaries },
  [datasetSteps.SETTINGS.name]: { component: DatasetSettings },
};

const DatasetWizardContent = ({
  activeStep,
  category,
  code,
  compact,
  title,
  readErrors,
  url,
}) => {
  const content = wizardContent[activeStep];
  const Component = content.component;

  return (
    <Component
      category={category}
      code={code}
      compact={compact}
      readErrors={readErrors}
      section={content.section}
      title={title}
      url={url}
    />
  );
};

export default DatasetWizardContent;
